import React from "react";
import SubHeader from "components/SubHeader";
import { ROUTES } from "shared/constants/routes";
import ProductHeader from "pages/dtf-transfers/by-size/ProductHeader";
import ProductGallery from "pages/dtf-transfers/by-size/ProductGallery";
import PromoBar from "pages/dtf-transfers/by-size/PromoBar";
import UploadArtwork from "pages/dtf-transfers/by-size/UploadArtwork";
import {
  Container,
  PageCard,
  PageLayout,
  GalleryColumn,
  ContentColumn,
} from "styles/pages/dtf-transfers/by-size";

const DtfTransfersBySize = () => {
  return (
    <Container>
      <SubHeader
        title={ROUTES.DTF_TRANSFERS_BY_SIZE.TITLE}
        links={[
          {
            title: ROUTES.HOME.TITLE,
            to: ROUTES.HOME.LINK,
          },
          {
            title: ROUTES.DTF_TRANSFERS.TITLE,
            to: ROUTES.DTF_TRANSFERS_BY_SIZE.LINK,
          },
        ]}
        currentPageTitle={ROUTES.DTF_TRANSFERS_BY_SIZE.TITLE}
      />

      <PageCard>
        <PageLayout>
          <GalleryColumn>
            <ProductGallery />
          </GalleryColumn>

          <ContentColumn>
            <ProductHeader />
            {/* <PromoBar /> */}
            <UploadArtwork />
          </ContentColumn>
        </PageLayout>
      </PageCard>
    </Container>
  );
};

export default DtfTransfersBySize;
